import styled from 'styled-components'

export const FilterWrapper = styled.div`
  flex: 1;
`
